import { render } from "./advertise.vue?vue&type=template&id=52364b26&scoped=true&ts=true"
import script from "./advertise.vue?vue&type=script&lang=ts"
export * from "./advertise.vue?vue&type=script&lang=ts"

import "./advertise.vue?vue&type=style&index=0&id=52364b26&lang=less&scoped=true"

import exportComponent from "../../../node_modules/.store/vue-loader@17.4.2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-52364b26"]])

export default __exports__